module.exports = __webpack_public_path__ + "static/media/GAME_RECORD.29d0489f.svg";